import MarkerType from "../enums/markerType";
import BasicCommunitySummaryCard from '../components/summaryCard/basicCommunityCard';
import BasicPlanSummaryCard from '../components/summaryCard/basicPlanCard';
import BasicSpecSummaryCard from '../components/summaryCard/basicSpecCard';
import PaidCommunitySummaryCard from '../components/summaryCard/paidCommunityCard';
import PaidPlanSummaryCard from '../components/summaryCard/paidPlanCard';
import PaidSpecSummaryCard from '../components/summaryCard/paidSpecCard';
import CommunityLabel from '../components/summaryCard/communityLabel';
import HomeLabel from '../components/summaryCard/homeLabel';

/**
 * Returns a summary card based on the provided data.
 * @param {Object} data - The data object containing information about the card.
 * @returns {Object} - The summary card object.
 */
function getCardInstance(data) {
  switch (data.Type) {
    case MarkerType.HousingDevelopment.toString():
      return data.IsBasic ? new BasicCommunitySummaryCard() : new PaidCommunitySummaryCard();
    case MarkerType.PlanUnit.toString():
      return data.IsBasic ? new BasicPlanSummaryCard() : new PaidPlanSummaryCard();
    case MarkerType.SpecUnit.toString():
      return data.IsBasic ? new BasicSpecSummaryCard() : new PaidSpecSummaryCard();
    default:
      return new PaidCommunitySummaryCard();
  }
}

/**
 * Retrieves the label for a summary card.
 * @param {Object} summaryCard - The summary card object.
 * @returns {Object} - The label object.
 */
function getLabel(summaryCard) {
  let label;

  if (summaryCard.Type === MarkerType.HousingDevelopment.toString()) {
    label = new CommunityLabel();
    label.setInformation(summaryCard);
  } else {
    label = new HomeLabel();
    label.setInformation(summaryCard);
  }

  return label;
}

/**
 * Retrieves a summary card based on the given data.
 * 
 * @param {Object} data - The data used to generate the summary card.
 * @returns The generated summary card.
 */
const getCard = (data) => {
  const card = getCardInstance(data);
  const label = getLabel(data);
  card.setInformation(data);
  card.setLabel(label);

  return card;
}

export default getCard;


/**
 * Combines and sorts a list of listings (plans and specs) based on a provided order.
 * @param {Object[]} listings - An object containing arrays of plans and specs.
 * @param {string} order - A comma-separated string of IDs representing the desired order.
 * @returns {Object[]} - The combined and sorted array of listings.
 */
export const combineAndSortListings = (listings, sortOrder) => {
  // Merge plans and specs into a single array
  const combinedListings = [...listings.plans, ...listings.specs];

  // Create an array of IDs based on the sort order
  const sortedIds = sortOrder.split(',');
  // Iterate over the order list and get the corresponding item from combined listings
  const sortedListings = combinedListings.sort((a, b) => {
    const aIndex = sortedIds.indexOf(a.Id.toString());
    const bIndex = sortedIds.indexOf(b.Id.toString());
    return aIndex - bIndex;
  });

  return sortedListings;
}
